import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { Header } from "Components/DP/DPTable/DPTable";


export const useReportHeaderOptions = (reportHeaders: Header[]) => {
  const { companies } = usePartnerConfig();
  const showPayGroupColumn = companies.length > 1;

  const visibleHeaders = showPayGroupColumn
    ? reportHeaders
    : reportHeaders.filter(header => header !== "Pay Group");

  return {
    showPayGroupColumn,
    visibleHeaders,
  };
};
